import DataTable from 'react-data-table-component'
import styles from '../AddNewVoucher.module.scss'
import SecondaryButton from '../../../../../../components/common/SecondaryButton/SecondaryButton'

const ProductSelection = () => {

  const selectedProductsData = [
    { serialNo: 1, product: { image: '', name: 'Blue Colored Headphones', productId: '#123456789', stock: 300 } },
    { serialNo: 1, product: { image: '', name: 'Blue Colored Headphones', productId: '#123456789', stock: 300 } },
    { serialNo: 1, product: { image: '', name: 'Blue Colored Headphones', productId: '#123456789', stock: 300 } },
    { serialNo: 1, product: { image: '', name: 'Blue Colored Headphones', productId: '#123456789', stock: 300 } },
  ]

  const selectedProductsDatacolumns = [
    { name: 'Serial no.', selector: row => row.serialNo, minWidth: '100px', maxWidth: '150px' },
    {
      name: 'Product', cell: row => (
        <div className='d-flex gap-2'>
          <div>
            <img src={row.product.image} alt="" width={86} height={79} />
          </div>
          <div>
            <div>
              {row.product.name}
            </div>
            <div>
              Product ID: {row.product.productId}
            </div>
            <div>
              Stock: {row.product.stock}
            </div>
          </div>
        </div>
      )
    },
  ]

  return (
    <div>
      <div className={styles['heading']}>Product Selection</div>
      <div className='p-2 bg-white'>

        <div className={styles['wrapper']}>
          <div>
            <SecondaryButton name='Add Products' />
          </div>
          <div className='fw-medium'>
            Total Selected Products: <span className={styles['text-orange']}>6</span>
          </div>
          <DataTable data={selectedProductsData} columns={selectedProductsDatacolumns} />
        </div>
      </div>

    </div>
  )
}

export default ProductSelection